<template>
  <div class="container-fluid">
      <div class="home">
        <img src="@/assets/img/logo-probus.png" class="home--logo" />
        <router-link :to="{name: 'book'}" class="btn btn-block">Book a car</router-link>
        <router-link :to="{name: 'login'}" class="btn btn-block btn-secondary">Login</router-link>
      </div>
  </div>
</template>
